import React from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { fetchBrands, logOutUser, toggleProlongSessionModal } from "authActions.js";
import ModalOpacity from 'ModalOpacity.js';
import ProlongSession from 'ProlongSession.js';

let TopMenu = (props) => {

    const { isOpenProlongSessionModalObject, logOutUser } = props;
    const dispatch = useDispatch();
    // dissabled due to FOB changes
    // const getBrands = async() => {
    //     const brandsData = await fetchBrands();
    //     const countryCode = Cookies.get('countryCode');
    //     const currentBrand = Object.values(brandsData).find(brand => brand.countryCode === countryCode);
    //     processCustomDataProperties(currentBrand)
    //     redirectToTerminalIfWrongBrand()
    // };

    // const redirectToTerminalIfWrongBrand = () => {
    //     if (isConfigDisabledAndNotLocal('PREMIUM_ENABLED')) {
    //         const { pathname } = window.location;
    //         if (!pathname.includes('/terminal')) {
    //             location.replace(`${pathname}terminal/`)
    //         }
    //     }
    // }

    // useEffect(()=> {
    //     getBrands();
    // }, []);

    const closeModal = () => {
        dispatch(toggleProlongSessionModal(false));
    };

    const logout = () => {
        logOutUser(true);
    }
    
    return (
        <>
            <ModalOpacity isOpen={isOpenProlongSessionModalObject?.isOpen} 
                showHeaderIcon={true}
                borderRadius=".42rem"
                showHeader={true}
                showCloseIcon={false}
                titleColor="#ffffff"
                toggleOpen={logout}
                backgroundBody="#DEDEDE"
                backgroundHeader="#019A44"
                width="96%"
                padding="0px"
                headerPadding="0.85rem 0 0.85rem 0">
                    <ProlongSession toggleProlongSessionModal={closeModal}></ProlongSession>
            </ModalOpacity>
        </>
    );

};

const mapStateToProps = (state, props) => {
    const {Auth: {isLogged, user, isOpenProlongSessionModalObject}} = state;
    
    return {
        isLogged,
        user,
        isOpenProlongSessionModalObject
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchBrands: bindActionCreators(fetchBrands, dispatch),
        logOutUser: bindActionCreators(logOutUser, dispatch),
        dispatch
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);